import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';

import FlagPostModal from './components/FlagPostModal';

export default function () {
  extend(PostControls, 'userControls', function (items, post) {
    if (post.user() == app.session.user || post.isHidden() || post.contentType() !== 'comment' || !post.canFlag() || post.user().groups().length != 0) return;

    items.add(
      'flag',
      <Button icon="img-more-jb" onclick={() => app.modal.show(FlagPostModal, { post })}>
        {app.translator.trans('flarum-flags.forum.post_controls.flag_button')}
      </Button>
    );
  });

  extend(DiscussionControls, 'userControls', function (items, discussion) {
    let post = discussion.firstPost();
    
    if (post.user() == app.session.user ||post && post.isHidden() || !post.canFlag() || post.user().groups().length != 0) return;
    items.add(
      'flag',
      <Button icon="img-more-jb" onclick={() => app.modal.show(FlagPostModal, { post })}>
        {app.translator.trans('flarum-flags.forum.post_controls.flag_button')}
      </Button>
    );
  });
}
